module.exports = __webpack_public_path__ + "static/media/logo.48eac1e9.svg";